<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{$route.meta.title}}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter"  :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="创建时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段" style="width: 100%" @on-ok="dateOk" @on-change="dateChange" @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <Table :columns="columns" stripe  :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >
        <template slot-scope="{ row, index }" slot="action">
          <a @click="del(row.goods_comment_id)">删除</a>
        </template>
      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page" show-total  @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import { goodsCommentsListApi, goodsCommentsDelApi } from '@/api/goods/goodsComments'

export default {
  name: 'goodsCommentsList',
  inject: ['reload'],
  data () {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        ctime: [],
      },
      tableData: [],
      tableCount: 0,
      loading: false,
      columns: [
        {
          title: '店铺名称',
          key: 'shop_name',
          minWidth: 180
        },
        {
          title: '商品名称',
          key: 'goods_name',
          minWidth: 180
        },
        {
          title: '评价用户',
          key: 'nickname',
          minWidth: 150
        },
        {
          title: '评价内容',
          key: 'comment',
          minWidth: 300
        },
        {
          title: '评价图片',
          key: 'pictures',
          minWidth: 300,
          render: (h, params) => {
            // pictures是一个图片数组 循环展示
            return h('div', this.tableData[params.index].pictures.map(item => {
              return h('img', {
                attrs: {
                  src: item
                },
                style: {
                  width: '40px',
                  height: '40px',
                  margin: '2px',
                },
                on: {
                  click: () => {
                    this.showImageModal(item || '')
                  }
                }
              })
            }))
          }
        },
        {
          title: '创建时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '操作',
          slot: 'action',
          fixed: 'right',
          minWidth: 100
        }
      ]
    }
  },
  created () {
    this.loadTableData()
  },
  methods: {
    loadTableData () {
      this.loading = true
      goodsCommentsListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage (status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search () {
      this.filter.page = 1
      this.loadTableData()
    },
    // 清空搜索
    searchClear () {
      this.filter.search = ''
      this.filter.page = 1
      this.loadTableData()
    },
    // 下拉选择
    select (status) {
      this.filter.page = 1
      this.loadTableData()
    },
    // 选择时间
    dateOk(){
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr){
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear(){
      this.filter.ctime = []
      this.loadTableData()
    },

    // 添加
    add () {
      this.$router.push({ path: this.pathFormat(this.$route.path) })
    },
    // 编辑
    edit (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'edit', id) })
    },
    // 详情
    info (id) {
      this.$router.push({ path: this.pathFormat(this.$route.path, 'info', id) })
    },

    // 删除
    del (id) {
      this.$Modal.confirm({
        title: '提示',
        content: '是否确认删除？',
        onOk: () => {
          goodsCommentsDelApi(id).then(res => {
            if (res.code === 200) {
              this.$Message.success('删除成功')
              this.reload()
            } else {
              this.$Message.error(res.msg)
            }
          }).catch(res => {
            this.$Message.error(res.msg)
          })
        }
      })
    },

  }
}
</script>
